import type { ApiResponse, User } from '@/types/site';
import { useSuspenseQuery } from '@tanstack/react-query';
import { XHRAuthorizedClient } from '../client';
import { ENDPOINTS } from '../endpoints';
import { QUERY_KEYS } from '../query-key';

export const useMeQuery = () => {
  return useSuspenseQuery({
    queryKey: [QUERY_KEYS.users.getMe],
    queryFn: async () => {
      const response = await XHRAuthorizedClient.get<ApiResponse<User>>(
        ENDPOINTS.users.me
      );
      return response.data.data;
    },
  });
};
